import TitleHeader from "@/components/TitleHeader";
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  Text,
  Image,
} from "@chakra-ui/react";
import { useUserInfo } from "@/context/UserInfo";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
import { LogsButton } from "@/components/Button";
import { useState } from "react";
import { GoIcon } from "@/components/icons";
import Keyboard from "@/components/keyboard";

const TaxModal = ({
  taxValue,
  handleSetTaxValue,
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
  taxValue: string;
  handleSetTaxValue: (value: string) => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("0");

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"} autoFocus={false}>
      <ModalContent sx={{ height: "100%" }}>
        <ModalBody
          sx={{
            height: "100%",
            padding: "0",
            width: "100%",
          }}
        >
          <Flex
            flexDir={"column"}
            align={"center"}
            sx={{
              height: "100%",
              padding: "20px 20px 240px",
              position: "relative",
            }}
          >
            <TitleHeader
              color="#D8762B"
              onBack={() => onClose()}
              title="Tax Setting"
            />
            <Text
              sx={{
                marginTop: "20px",
                color: "#848484",
                fontSize: "14px",
                fontWeight: 700,
              }}
            >
              Edit Tax
            </Text>
            <Box
              sx={{
                position: "relative",
                padding: "0 20px",
              }}
            >
              <Text
                sx={{
                  fontSize: "70px",
                  fontStyle: "normal",
                  fontWeight: 900,
                  minHeight: "70px",
                  textAlign: "center",
                  position: "relative",
                  wordBreak: "break-all",
                  fontFamily: "DIN-Black",
                }}
              >
                {value}
                <span style={{ fontSize: "40px", fontWeight: 900 }}>%</span>
              </Text>
            </Box>

            <LogsButton
              variant="outlined"
              sx={{
                width: "160px",
                height: "70px",
                borderRadius: "100px",
                marginTop: "16px",
              }}
              loading={loading}
              onClick={() => {
                handleSetTaxValue(value);
                onClose();
              }}
            >
              <Text
                sx={{
                  marginLeft: "auto",
                  marginRight: "20px",
                }}
              >
                Confirm
              </Text>
              <GoIcon
                style={{
                  width: "14px",
                  height: "11px",
                  marginRight: "30px",
                }}
              ></GoIcon>
            </LogsButton>

            <Keyboard
              value={value}
              onKeyboardClick={(value: string) => {
                setValue(value);
              }}
            ></Keyboard>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TaxModal;
